// hooks/useApplicationData.js
import axios from 'axios';
import { useDispatch } from 'react-redux';
import {
  setAppetiteData,
  selectedApplicationData,
  setTotalApplications,
  setUniqueValues,
  setAppId,
  setSelectedAppIdName,
  setSelectedApplicationIdData
} from '../store/ApplicationSlice';
import { useNavigate } from 'react-router-dom';
import {
  fetchAppUniqueValues,
  fetchTotalApplications,
  fetchApplicationDataByIdAndName
} from '../api/userService';

const useApplicationData = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchApplicationData = async (
    accessToken,
    refreshToken,
    page = 1,
    limit = 15
  ) => {
    const skip = (page - 1) * limit; // Calculate skip value

    const headers = {
      'X-Access-Token': accessToken,
      'X-Refresh-Token': refreshToken,
      Accept: 'application/json'
    };

    // Extract application id from URL if available
    const pathParts = window.location.pathname.split('/');
    const dynamicAppId = pathParts[pathParts.length - 1] || '';
    const hasDynamicId =
      dynamicAppId && dynamicAppId.toLowerCase().startsWith('cipilotiaiapp');

    const url = `https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v2/application_filter?skip=${skip}&limit=${limit}`;

    try {
      const response = await axios.get(url, { headers });
      dispatch(setAppetiteData(response.data));
      if (hasDynamicId) {
        const response = await axios.get(
          `https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v2/application_filter?application_id=${dynamicAppId}`,
          { headers }
        );
        const filteredData = response?.data;
        if (filteredData.length > 0) {
          dispatch(selectedApplicationData(filteredData[0]));
          dispatch(setSelectedAppIdName(filteredData[0]?.customer_name)); // Set the application name in the Redux store
          dispatch(setAppId(filteredData[0]?.application_id)); // Set the application ID in the Redux store
          const response = await fetchApplicationDataByIdAndName(
            filteredData[0]?.customer_name,
            filteredData[0]?.application_id
          );
          dispatch(setSelectedApplicationIdData(response));
        } else {
          navigate('/');
        }
      } else {
        dispatch(selectedApplicationData(response.data[0]));
        dispatch(setSelectedAppIdName(response.data[0]?.customer_name)); // Set the application name in the Redux store
        dispatch(setAppId(response.data[0]?.application_id)); // Set the application ID in the Redux store
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Handle unauthorized access
        navigate('/');
      } else {
        // Handle other errors
        console.error('Error fetching application data:', error);
      }
    }
  };

  const fetchTotalApplicationsCount = async (accessToken, refreshToken) => {
    try {
      const response = await fetchTotalApplications(accessToken, refreshToken);
      dispatch(setTotalApplications(response.total));
    } catch (error) {
      navigate('/');
    }
  };

  const fetchUniqueValues = async (accessToken, refreshToken) => {
    try {
      const response = await fetchAppUniqueValues(accessToken, refreshToken);
      dispatch(setUniqueValues(response));
    } catch (error) {
      navigate('/');
    }
  };

  return {
    fetchApplicationData,
    fetchTotalApplicationsCount,
    fetchUniqueValues
  };
};

export default useApplicationData;
